import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { StoryCard } from "@/components/StoryCard";

export default function Stories() {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    let cancelled = false;
    async function load(attempt = 0) {
      try {
        const r = await api.get("/stories?limit=48");
        if (cancelled) return;
        setStories(r.data || []);
        setLoading(false);
      } catch (e) {
        if (cancelled) return;
        if (attempt === 0) return load(1);
        setError(e.message || "Could not load stories");
        setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 md:py-16">
      <div className="mb-8">
        <div className="font-mono text-[11px] uppercase tracking-[0.24em] text-amber-400 mb-2">Library</div>
        <h1 className="font-serif text-3xl md:text-5xl font-bold tracking-tight">Every story, ever imagined.</h1>
        <p className="mt-3 text-slate-400 max-w-2xl">Preview the first two chapters free. Subscribe to unlock the ending on every tale in the archive.</p>
      </div>
      {loading ? (
        <div data-testid="stories-loading" className="text-slate-500 text-sm">Loading the shelves…</div>
      ) : error ? (
        <div data-testid="stories-error" className="text-rose-300 text-sm">Couldn't load the archive — <button onClick={() => window.location.reload()} className="underline">reload</button>.</div>
      ) : stories.length === 0 ? (
        <div className="text-slate-500 text-sm">No stories yet.</div>
      ) : (
        <div data-testid="stories-grid" className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-6">
          {stories.map((s) => <StoryCard key={s.story_id} story={s} />)}
        </div>
      )}
    </div>
  );
}
